import axiosClient from "api/apiClient";

interface IOptions {
    page: string;
    sort?: string;
    order?: string;
    search?: string;
    export?: boolean;
}

export const APIGetStudents = (options: IOptions) => {
    let sort = "";
    let search = "";
    let exportData = "";

    if (options.hasOwnProperty("sort")) {
        if (options.order === "asc") {
            sort = "&sort=" + options.sort;
        } else if (options.order === "desc") {
            sort = "&sort=-" + options.sort;
        }
    }
    if (options.hasOwnProperty("search")) {
        search = "&filter[search]=" + options.search;
    }

    if (options.hasOwnProperty("export")) {
        if (options.export) {
            exportData = "&export=true";
        }
    }

    return axiosClient.get(`/students${options.page}${search}${sort}${exportData}`);
};
